import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { HelpersService } from './helpers.service';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class CollectionsV2Service {
  private apiURL: string = '';
  private apiURLNew: string = '';
  private apiKey: string = '';
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
    this.apiURLNew = this.appConfig.getEnvironmentNew().url;
    this.apiKey = this.appConfig.getApiKey();
    this.env = this.appConfig.getEnvironmentNew();
  }

  getAllLinkedPartners(partnerID, feature = "WORKSHOP") {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.env.url}/Bikeshop/Collections/${this.helpersService.getPartnerId()}/GetLinkedPartners/All?code=${this.env.key}&Feature=${feature}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getEnabledLinkedPartners(partnerID, feature = "WORKSHOP") {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.env.url}/Bikeshop/Collections/${this.helpersService.getPartnerId()}/GetLinkedPartners/Enabled?code=${this.env.key}&Feature=${feature}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  updatePartnerMasterConfig(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        `${this.env.url}/Bikeshop/Collections/MasterConfiguration?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getVehicleList(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.env.url}/Bikeshop/Collections/${this.helpersService.getPartnerId()}/VehicleList?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  deleteVehicle(partnerID, itemID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        `${this.env.url}/Bikeshop/Collections/${partnerID}/DeliveryVehicle/${itemID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  addVehicle(partnerID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        `${this.env.url}/Bikeshop/Collections/DeliveryVehicle/${this.helpersService.getPartnerId()}?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  updateVehicle(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        `${this.env.url}/Bikeshop/Collections/DeliveryVehicle?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getCutOffRules(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.env.url}/Bikeshop/Collections/${this.helpersService.getPartnerId()}/CutOffRules?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  deleteCutOffRule(partnerID, itemID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        `${this.env.url}/Bikeshop/Collections/${partnerID}/CutOffRule/${itemID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  addCutOffRule(partnerID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        `${this.env.url}/Bikeshop/Collections/CutOffRule/${this.helpersService.getPartnerId()}?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  updateCutOffRule(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        `${this.env.url}/Bikeshop/Collections/CutOffRule?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getDefaultSlots(partnerID, feature) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.env.url}/Bikeshop/Collections/${this.helpersService.getPartnerId()}/Slots?code=${this.env.key}&Feature=${feature}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  deleteDefaultSlots(partnerID, itemID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        `${this.env.url}/Bikeshop/Collections/${partnerID}/DefaultSlot/${itemID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  addDefaultSlots(partnerID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        `${this.env.url}/Bikeshop/Collections/DefaultSlot/${this.helpersService.getPartnerId()}?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  updateDefaultSlots(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        `${this.env.url}/Bikeshop/Collections/DefaultSlot?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getDeliveryAreas(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.env.url}/Bikeshop/Collections/${this.helpersService.getPartnerId()}/DeliveryAreas?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  deleteDeliveryAreas(partnerID, itemID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        `${this.env.url}/Bikeshop/Collections/${partnerID}/DeliveryArea/${itemID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  addDeliveryAreas(partnerID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        `${this.env.url}/Bikeshop/Collections/DeliveryArea/${this.helpersService.getPartnerId()}?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  updateDeliveryAreas(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        `${this.env.url}/Bikeshop/Collections/DeliveryArea?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getOverrideSlots(partnerID, feature) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.env.url}/Bikeshop/Collections/${this.helpersService.getPartnerId()}/OverrideSlots?code=${this.env.key}&Feature=${feature}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  deleteOverrideSlot(partnerID, itemID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        `${this.env.url}/Bikeshop/Collections/${partnerID}/OverrideSlot/${itemID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  addOverrideSlot(partnerID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        `${this.env.url}/Bikeshop/Collections/OverrideSlot/${this.helpersService.getPartnerId()}?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  updateOverrideSlot(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        `${this.env.url}/Bikeshop/Collections/OverrideSlot?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getUnavailableDates(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.env.url}/Bikeshop/Collections/${this.helpersService.getPartnerId()}/UnavailableDates?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  deleteUnavailableDate(partnerID, itemID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        `${this.env.url}/Bikeshop/Collections/${partnerID}/UnavailableDate/${itemID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  addUnavailableDate(partnerID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        `${this.env.url}/Bikeshop/Collections/UnavailableDate/${this.helpersService.getPartnerId()}?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  updateUnavailableDate(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        `${this.env.url}/Bikeshop/Collections/UnavailableDate?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  updateRentalsConfig(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        `${this.env.url}/Bikeshop/Rentals/Collections/Configuration?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }
}
